import React from 'react';
import PropTypes from 'prop-types';
import { map, noop } from 'lodash';
import {
  TableRow,
  TableRowColumn,
} from '@unite-us/app-components';
import { DynamicTableRowColumn } from '.';
import { isLockedRow } from '../utils';
import { iconColStyle } from '../styles/dynamicTableStyles';

const DynamicTableRow = ({
  columnLabels, data, hideRowIcon, id, rowIcon, rowProps, ...props
}) => (
  <TableRow
    {...props}
    {...rowProps}
    className={isLockedRow(data.permissions) ? 'unauthorized' : ''}
    id={id}
  >
    {
      !hideRowIcon && (
        <TableRowColumn
          className="dynamic-table__row-column"
          style={{ overflow: 'visible', ...iconColStyle }}
          {...props}
        >
          {rowIcon(data)}
        </TableRowColumn>
      )
    }
    {
      map(columnLabels, (columnLabel, i) => (
        <DynamicTableRowColumn
          {...props}
          key={`table-row-column-${data?.id}-${columnLabel.label || i}`}
          columnLabel={columnLabel}
          data={data}
        />
      ))
    }
  </TableRow>
);

DynamicTableRow.propTypes = {
  columnLabels: PropTypes.array.isRequired,
  data: PropTypes.shape({
    permissions: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  hideRowIcon: PropTypes.bool,
  id: PropTypes.string.isRequired,
  rowIcon: PropTypes.func,
  rowProps: PropTypes.object,
};

DynamicTableRow.defaultProps = {
  hideRowIcon: false,
  rowIcon: noop,
  rowProps: {},
};

export default DynamicTableRow;
